import { render, staticRenderFns } from "./MainDrawer.vue?vue&type=template&id=e84fa852&scoped=true"
import script from "./mainDrawer.ts?vue&type=script&lang=ts&external"
export * from "./mainDrawer.ts?vue&type=script&lang=ts&external"
import style0 from "./MainDrawer.vue?vue&type=style&index=0&id=e84fa852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84fa852",
  null
  
)

export default component.exports